import { Link } from "react-router-dom";
import { ASSETS } from "@/lib/assets";

export default function Logo({ className = "", onClick }) {
  return (
    <Link
      to="/"
      onClick={onClick}
      data-testid="logo-home-link"
      aria-label="Waidbook home"
      className={`flex items-center ${className}`}
    >
      <img
        src={ASSETS.logoSmall}
        alt="Waidbook"
        className="h-11 w-auto md:h-12"
        draggable="false"
      />
    </Link>
  );
}
